export default {
  showReleasesIcon(state) {
    return state.showReleasesIcon;
  },
  hasRecentRelease(state) {
    return state.hasRecentRelease;
  }
};
